import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, User } from "lucide-react";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const isTest = loc.pathname.startsWith("/test/") || loc.pathname.startsWith("/demo");

  if (isTest) return null;

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-40 border-b border-white/10 backdrop-blur-xl bg-black/70"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-2">
        <Link
          to="/"
          data-testid="header-logo"
          className="flex items-center gap-2 sm:gap-3 group flex-shrink-0"
        >
          <div className="w-8 h-8 sm:w-9 sm:h-9 bg-[#CCFF00] flex items-center justify-center rounded-sm rotate-45 group-hover:rotate-90 transition-transform duration-300">
            <span className="font-heading font-black text-black text-base sm:text-lg -rotate-45 group-hover:-rotate-90 transition-transform duration-300">
              F
            </span>
          </div>
          <div>
            <div className="font-heading font-black tracking-tight text-lg sm:text-xl leading-none">
              FMP
            </div>
            <div className="hidden sm:block font-display text-[10px] tracking-widest text-white/40 mt-0.5">
              Football Motivation Profile
            </div>
          </div>
        </Link>

        <nav className="flex items-center gap-2 sm:gap-4">
          {user ? (
            <>
              <Link
                to="/dashboard"
                data-testid="nav-dashboard"
                className="text-xs sm:text-sm font-heading font-semibold text-white/80 hover:text-[#CCFF00] transition-colors"
              >
                Dashboard
              </Link>
              <div className="hidden md:flex items-center gap-2 text-sm text-white/60">
                <User className="w-4 h-4" />
                <span data-testid="nav-user-name">{user.name}</span>
              </div>
              <button
                data-testid="nav-logout-btn"
                onClick={async () => {
                  await logout();
                  navigate("/");
                }}
                className="btn-ghost !py-1.5 !px-3 sm:!py-2 sm:!px-4 text-[10px] sm:text-xs"
                title="Logout"
              >
                <LogOut className="w-4 h-4" />
                <span className="hidden sm:inline">Logout</span>
              </button>
            </>
          ) : (
            <>
              <Link
                to="/demo"
                data-testid="nav-demo"
                className="text-xs sm:text-sm font-heading font-semibold text-white/70 hover:text-[#CCFF00] transition-colors"
              >
                Demo
              </Link>
              <Link
                to="/login"
                data-testid="nav-login"
                className="text-xs sm:text-sm font-heading font-semibold text-white/70 hover:text-[#CCFF00] transition-colors"
              >
                Login
              </Link>
              <Link
                to="/register"
                data-testid="nav-register"
                className="btn-primary !py-1.5 !px-3 sm:!py-2 sm:!px-4 text-[10px] sm:text-xs"
              >
                <span className="hidden sm:inline">Trainer werden</span>
                <span className="sm:hidden">Trainer</span>
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
